import React from 'react';
import { MapLegend } from 'components/MapElements/MapLegend';
import { ExportElement } from 'components/MapElements/ExportElement';
import { LangBtns } from 'components/MapElements/LangBtns';
import { LayersElement } from 'components/MapElements/LayersElement';
import { RulerElement } from 'components/MapElements/RulerElement';
import { Box } from '@mui/material';
import { HomeElement } from './HomeElement';
import { FullscreenElement } from './FullscreenElement';
import { DynamicSeriesElement } from './DynamicSeriesElement';
import { MetadataElement } from './MetadataElement';

export const MapElements: React.FC = (): JSX.Element => {
  return (
    <>
      <Box className="map-elements-wrapper">
        <MetadataElement />
        <DynamicSeriesElement />
        <RulerElement />
        <ExportElement />
        <FullscreenElement />
        <HomeElement />
        <MapLegend />
      </Box>
      <Box id="top-map-elements-wrapper">
        <LangBtns />
        <Box>
          <Box id="zoom" />
          <LayersElement />
        </Box>
      </Box>
    </>
  );
};
